export const STORAGE_RBD = 'rbd'
export const STORAGE_GPFS = 'gpfs'
export const STORAGE_NFS = 'nfs'

// kvm 共享存储
export const KVM_SHARE_STORAGES = [
  STORAGE_RBD,
  STORAGE_GPFS,
  STORAGE_NFS,
]
